import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=d13740d8&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"
import style0 from "./Portal.vue?vue&type=style&index=0&id=d13740d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13740d8",
  null
  
)

export default component.exports